import React, { useEffect, useState } from "react";
import { Row, Col, Card, CardBody, Button, Input, FormGroup, Label, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import Models from './model.json';
import "./tables.scss";
import "./Puestos.scss";
import { httpGet, httpPost, httpPUT, httpDelete } from "../../../src/common/petitions";
import DataLoader from "../../components/tableData";
import { useNavigate } from 'react-router-dom';

const Combustible = () => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [modal, setModal] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [typeGas, setTypeGas] = useState('');
  const [cost, setCost] = useState('');
  const [identifier, setIdentifier] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const rowsData = await httpGet(`/gasolina/20242025`, navigate);
      const jsonData = { columns: Models.fuel, rows: rowsData.data };
      setData(jsonData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setIsLoading(false);
  };

  const toggleModal = () => {
    setModal(!modal);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === 'typeGas') setTypeGas(value);
    if (name === 'cost') setCost(value);
    if (name === 'identifier') setIdentifier(value);
  };

  const handleSubmit = async () => {
    console.log(isUpdate);
    try {
      if (isUpdate) {
        await httpPUT(`/gasolina/${selectedItem.idunique}`, { typegas: typeGas, cost: parseFloat(cost), identifier }, navigate);
      } else {
        await httpPost(`/gasolina`, { typegas: typeGas, cost: parseFloat(cost), identifier, periodo: '20242025' }, navigate);
      }
      fetchData();
      toggleModal();
    } catch (error) {
      console.error("Error submitting data:", error);
    }
  };

  const handleEdit = (item) => {
    console.log("Editing item:", item.tipo); // Log the item being edited
    setSelectedItem(item);
    setTypeGas(item.tipo || '');
    setCost(item.precio || '');
    setIdentifier(item.identifier || '');
    setIsUpdate(true);
    toggleModal();
  };

  const handleDelete = async (id) => {
    console.log(id);
    if (window.confirm("Al borrar este elemento no podra recuperarlo?")) {
      try {
        await httpDelete(`/gasolina/${id}`, navigate);
        fetchData();
      } catch (error) {
        console.error("Error deleting item:", error);
      }
    }
  };

  const handleCreate = () => {
    setSelectedItem(null);
    setTypeGas('');
    setCost('');
    setIdentifier('');
    setIsUpdate(false);
    toggleModal();
  };

  document.title = "Combustibles - Precios - IPG";
  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs maintitle="Combustibles" title="Precios" />

          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <Button color="primary" onClick={handleCreate}>Agregar Combustible</Button>
                  {<DataLoader isLoading={isLoading} data={data} handleEdit={handleEdit} handleDelete={handleDelete} />}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      <Modal isOpen={modal} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>{isUpdate ? 'Actualizar combustible' : 'Agregar combustible'}</ModalHeader>
        <ModalBody>
          <Row>
            <Col className="col-6">
              <FormGroup>
                <Label for="typeGas">Tipo Combustible</Label>
                <Input type="text" name="typeGas" id="typeGas" value={typeGas} onChange={handleInputChange} />
              </FormGroup>
            </Col>
            <Col className="col-6">
              <FormGroup>
                <Label for="cost">Costo</Label>
                <Input type="number" name="cost" id="cost" value={cost} onChange={handleInputChange} />
              </FormGroup>
            </Col>
            <Col className="col-6">
              <FormGroup>
                <Label for="identifier">Identificador</Label>
                <Input type="text" name="identifier" id="identifier" value={identifier} onChange={handleInputChange} />
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleSubmit}>{isUpdate ? 'Actualizar' : 'Agregar'}</Button>{' '}
          <Button color="secondary" onClick={toggleModal}>Cancelar</Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

export default Combustible;
